<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout
          class="d-flex flex-lg-row flex-md-column flex-sm-column"
          wrap
          pa-3
        >
          <v-flex lg6 md6 sm12>
            <v-text-field
              v-model="selectedItem.SessionCode"
              label="Mã phiên làm việc"
              class="input-group--focused"
              :readonly="selectedItem.Status == 2"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              label="Trạng thái"
              v-model="sessionStatus"
              :items="SESSION_STATUS"
              item-text="name"
              item-value="value"
              :readonly="selectedItem.Status == 2"
            ></v-select>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-select
              label="Nhân viên"
              v-model="selectedItem.StaffIDs"
              :items="staff_list"
              item-text="FullName"
              item-value="ID"
              multiple
              :readonly="selectedItem.Status == 2"
            ></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              label="Tổng số kiện"
              v-model="selectedItem.TotalPackage"
              :decimal="0"
              class="input-group--focused"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              label="Tổng số cân"
              v-model="selectedItem.TotalWeight"
              :decimal="1"
              class="input-group--focused"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              label="Tổng số khối"
              v-model="selectedItem.TotalVolume"
              :decimal="2"
              class="input-group--focused"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-textarea
              label="Ghi chú"
              v-model="selectedItem.Note"
              rows="5"
              class="input-group--focused"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    <v-container grid-list-xl fluid mt-4>
      <v-card>
        <v-layout row class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
          <v-flex lg12 md12 sm12 >
            <v-btn @click="dialogNewTran = true" v-if="selectedItem.Status != 2">Thêm mới</v-btn>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-data-table
              :headers="headers"
              :items="items"
              :options.sync="pagination"
              :server-items-length="total_rows"
              :footer-props="items_per_page"
              :must-sort="true"
              :loading="loading"
              :mobile-breakpoint="100"
            >
            <template v-slot:item="{ item }">
              <tr>
                <td v-bind:class="item.OrderID == null ? 'text-red' : ''">{{ item.TransactionCode }}</td>
                <td>{{ (item.PackageType === 1 ? 'KG' : 'RV') +item.OrderID }}</td>
                <td>{{ item.Username }}</td>
                <td class="text-end" v-if="item.Status == 5 || sessionStatus == 2">{{ item.Weight | currency('', 1) }}</td>
                <td class="text-end" v-else>
                  <h-currency-input label="Cân nặng" v-model="item.Weight" :decimal="1" class="input-group--focused" @on_blur="saveTranItem({ID: item.ID, Weight: item.Weight})"></h-currency-input>
                </td>
                <td class="text-end" v-if="item.Status == 5 || sessionStatus == 2">{{ item.Length}}</td>
                <td class="text-end" v-else>
                  <h-currency-input label="Chiều dài" v-model="item.Length" :decimal="0" class="input-group--focused" @on_blur="saveTranItem({ID: item.ID, Length: item.Length})"></h-currency-input>
                </td>
                <td class="text-end" v-if="item.Status == 5 || sessionStatus == 2">{{ item.Width}}</td>
                <td class="text-end" v-else>
                  <h-currency-input label="Chiều rộng" v-model="item.Width" :decimal="0" class="input-group--focused" @on_blur="saveTranItem({ID: item.ID, Width: item.Width})"></h-currency-input>
                </td>
                <td class="text-end" v-if="item.Status == 5 || sessionStatus == 2">{{ item.Height}}</td>
                <td class="text-end" v-else>
                  <h-currency-input label="Chiều cao" v-model="item.Height" :decimal="0" class="input-group--focused" @on_blur="saveTranItem({ID: item.ID, Height: item.Height})"></h-currency-input>
                </td>
                <td class="text-end">{{ item.Volume | currency('', 2) }}</td>
                <td class="text-end">{{ item.WeightByVolume | currency('', 1) }}</td>
                <td class="truncate">
                  <v-edit-dialog
                  :return-value.sync="item.StoreVNNote"
                  large
                  lazy
                  persistent
                  @save="saveTranItem({ID: item.ID, StoreVNNote: item.StoreVNNote})"
                  >
                      <v-tooltip max-width="250" color="light-green lighten-5 black--text">
                          <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.StoreVNNote }}</span>
                          </template>
                          <span>{{ item.StoreVNNote }}</span>
                      </v-tooltip>
                      <template v-slot:input>
                          <v-textarea
                          v-model="item.StoreVNNote"
                          label="Ghi chú"
                          autofocus
                          ></v-textarea>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">{{ item.Note}}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" v-if="sessionStatus != 2" @click="dialogDuplicate = true; duplicateID = item.ID" :disabled="item.Status == 5">fa-copy</v-icon>
                  <v-icon medium class="mr-2" @click="saveTranItem({ID: item.ID, SessionID: 0})" v-if="sessionStatus != 2">fa-trash</v-icon>
                </td>
              </tr>
            </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogNewTran" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Nhập mã vận đơn</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-text-field label="Mã vận đơn" ref="trancode" v-model="newTran.TransactionCode" class="input-group--focused" @keyup.enter="focusNext"></v-text-field>
              </v-flex>
              <v-flex lg12>
                <h-currency-input label="Cân nặng" v-model="newTran.Weight" :decimal="1" class="input-group--focused" @press_enter="focusNext"></h-currency-input>
              </v-flex>
              <v-flex lg12>
                <h-currency-input label="Chiều dài" v-model="newTran.Length" :decimal="0" class="input-group--focused" @press_enter="focusNext"></h-currency-input>
              </v-flex>
              <v-flex lg12>
                <h-currency-input label="Chiều rộng" v-model="newTran.Width" :decimal="0" class="input-group--focused" @press_enter="focusNext"></h-currency-input>
              </v-flex>
              <v-flex lg12>
                <h-currency-input label="Chiều cao" v-model="newTran.Height" :decimal="0" class="input-group--focused" @press_enter="focusNext"></h-currency-input>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="saveNewTrancode">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDuplicate" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Nhập mã tương tự</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <h-currency-input label="Số mã" v-model="duplicateNumber" :decimal="0" class="input-group--focused"></h-currency-input>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="duplicateTrancode">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import configs from "@/configs";
import { mapState } from "vuex";
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
import _ from "lodash";
export default {
  data() {
    return {
      require_validation: [(v) => !!v || "Trường dữ liệu không được để trống."],
      get_status_color: this.$options.filters.display_color,
      dialogNewTran: false,
      dialogDuplicate: false,
      duplicateNumber: 0,
      duplicateID: 0,
      newTran: {},
      transactionCode: "",
      SESSION_STATUS: configs.SESSION_STATUS,
      package_status: configs.PACKAGE_STATUS,
      pagination: { ...configs.PAGINATION, sortBy: ["ModifiedDate"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã đơn hàng",
          value: "OrderID",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Khách hàng",
          value: "Username",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Cân nặng",
          value: "Weight",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Chiều dài",
          value: "Length",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Chiều rộng",
          value: "Width",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Chiều cao",
          value: "Height",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Số khối",
          value: "Volume",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Cân quy đổi",
          value: "WeightByVolume",
          filterable: true,
          align: "end",
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Note kiểm kho",
          value: "StoreVNNote",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Ghi chú",
          value: "Note",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      sessionStatus: 0,
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.sessions.loading,
      selectedItem: (state) => state.sessions.selected,
      items: state => state.orderTransaction.all.data,
      total_rows: state => state.orderTransaction.all.total,
      staff_list: (state) =>
        _.filter(state.commons.all_users, function(o) {
          return (
            (o.RoleType & configs.ROLE_TYPE.StoreVN) ==
            configs.ROLE_TYPE.StoreVN
          );
        }),
    }),
    modifyId() {
      return Number(this.$route.params.Pid);
    },
  },
  watch: {
    modifyId() {
      this.refreshData();
    },
    pagination: {
      handler: function (val, oldVal) {
        this.refreshData();
      },
      deep: true,
    },
    selectedItem() {
      this.sessionStatus = this.selectedItem.Status;
    }
  },
  methods: {
    focusNext(e) {
      const inputs = Array.from(e.target.ownerDocument.querySelectorAll('.input-group--focused input:not([type=hidden])'));
      const index = inputs.indexOf(e.target);
      if (index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
      else {
        this.saveNewTrancode();
      }
    },
    refreshData() {
        if (this.modifyId > 0) {
            this.$store.dispatch("sessions/getDetail", this.modifyId);
        } else {
            this.$store.commit("sessions/setDetail", {
            data: {
                ID: 0,
                SessionCode: ""
            },
            });
        }
        var param = {
          pagination: this.pagination,
          filter: [...this.filterConditions],
          quickFilter: this.quickFilterConditions
        };
        param.filter.push({column: "SessionID", value: this.modifyId, condition: "equal"});
        this.$store.dispatch("orderTransaction/getList", param);
        this.$store.dispatch("commons/getAllUsers");
    },
    saveData() {
      if(this.selectedItem.Status == 2) {
        sendErrorNotice('Không thể cập nhật phiên làm việc đã kết thúc.');
        return;
      }
      this.$store.dispatch("sessions/setDetail", {
        data: {
          ...this.selectedItem,
          ModifiedBy: this.$store.state.authentication.user.username,
          Status: this.sessionStatus
        },
        id: this.selectedItem.ID,
      });
      window.getApp.$emit("APP_NAVIGATE", "SessionList");
    },
    saveTranItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {data: item, id: item.ID})
    },
    openDialogNew() {
      if(!this.selectedItem.ID) {
        sendErrorNotice('Lưu lại phiên làm việc trước khi nhập mã vận đơn.');
        return;
      }
      this.openDialogNew = true;
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    saveNewTrancode: _.debounce(
      function() {
        var param = {
            filter: [{
              column: "TransactionCode",
              value: this.newTran.TransactionCode.trim(),
              condition: "s_equal"
            }]
        };
        const checkTran = _.find(this.items, {TransactionCode: this.newTran.TransactionCode.trim()})
        if(checkTran) {
          // if(checkTran.Status != 5) {
          //   this.$store.dispatch("orderTransaction/setDetail", {data: {Weight: this.newTran.Weight, Length: this.newTran.Length, Width: this.newTran.Width, Height: this.newTran.Height}, id: checkTran.ID})
          // }
          sendErrorNotice('Mã vận đơn đã có trong phiên làm việc.');
          this.newTran = {};
          this.$nextTick(() => this.$refs.trancode.focus());
          return;
        }
        request_list('order_transactions', ret => {
          if(ret.data.length > 0) {
            if(ret.data[0].SessionID > 0 && ret.data[0].SessionID != this.selectedItem.ID) {
              sendErrorNotice('Mã vận đơn thuộc phiên làm việc khác.');
              return;
            }
            this.$store.dispatch("orderTransaction/setDetail", {data: {Weight: this.newTran.Weight, Length: this.newTran.Length, Width: this.newTran.Width, Height: this.newTran.Height, SessionID: this.selectedItem.ID}, id: ret.data[0].ID})
            this.newTran = {};
            this.$nextTick(() => this.$refs.trancode.focus());
          }
          else {
            this.$store.dispatch("orderTransaction/setDetail", {data: {TransactionCode: this.newTran.TransactionCode.trim(), Weight: this.newTran.Weight, Length: this.newTran.Length, Width: this.newTran.Width, Height: this.newTran.Height, SessionID: this.selectedItem.ID, Status: 4}})
            this.newTran = {};
            this.$nextTick(() => this.$refs.trancode.focus());
          }
        }, Vue.http, param, this.$store.state.authentication.token);
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    duplicateTrancode() {
      this.$store.dispatch("orderTransaction/setDetail", {data: {RequestAction: 'Duplicate', DuplicateNumber: this.duplicateNumber}, id: this.duplicateID})
      this.dialogDuplicate = false;
    },
    exportSession() {
        this.$store.dispatch("orderTransaction/export_session", {'SessionID': this.selectedItem.ID, 'SessionCode': this.selectedItem.SessionCode});
    },
  },
  mounted() {
    this.refreshData();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
    this.$root.$on("REQUEST_CREATE_DATA", this.exportSession);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA");
    this.$root.$off("REQUEST_REFRESH_DATA");
    this.$root.$off("REQUEST_CREATE_DATA");
  },
};
</script>